import { Component } from '@angular/core';

@Component({
    selector: 'app-wrong-route',
    templateUrl: './wrong-route.component.html',
    styleUrls: ['./wrong-route.component.scss'],
    standalone: false
})
export class WrongRouteComponent {

}
